export class RenderOutput {
}
export class ChatRenderOutput extends RenderOutput {
    body;
}
export class SmsRenderOutput extends RenderOutput {
    body;
}
export class PushRenderOutput extends RenderOutput {
    subject;
    body;
}
export class EmailRenderOutput extends RenderOutput {
    subject;
    body;
    from;
}
export class DigestOutputProcessor {
    static isDigestRegularOutput(output) {
        if (typeof output !== 'object' || output === null)
            return false;
        const obj = output;
        return typeof obj.amount === 'number' && Object.values(TimeUnitEnum).includes(obj.unit);
    }
    static isDigestTimedOutput(output) {
        if (typeof output !== 'object' || output === null)
            return false;
        const obj = output;
        return typeof obj.cron === 'string' && (typeof obj.digestKey === 'undefined' || typeof obj.digestKey === 'string');
    }
}
class DigestRegularOutput {
    amount;
    unit;
    digestKey;
    lookBackWindow;
}
class DigestTimedOutput {
    cron;
    digestKey;
}
export class DelayRenderOutput extends RenderOutput {
    type;
    amount;
    unit;
}
export var TimeUnitEnum;
(function (TimeUnitEnum) {
    TimeUnitEnum["SECONDS"] = "seconds";
    TimeUnitEnum["MINUTES"] = "minutes";
    TimeUnitEnum["HOURS"] = "hours";
    TimeUnitEnum["DAYS"] = "days";
    TimeUnitEnum["WEEKS"] = "weeks";
    TimeUnitEnum["MONTHS"] = "months";
})(TimeUnitEnum || (TimeUnitEnum = {}));
export var RedirectTargetEnum;
(function (RedirectTargetEnum) {
    RedirectTargetEnum["SELF"] = "_self";
    RedirectTargetEnum["BLANK"] = "_blank";
    RedirectTargetEnum["PARENT"] = "_parent";
    RedirectTargetEnum["TOP"] = "_top";
    RedirectTargetEnum["UNFENCED_TOP"] = "_unfencedTop";
})(RedirectTargetEnum || (RedirectTargetEnum = {}));
export class InAppRenderOutput extends RenderOutput {
    subject;
    body;
    avatar;
    primaryAction;
    secondaryAction;
    data;
    redirect;
}
export class PreviewPayload {
    subscriber;
    payload;
    context;
    steps; // step.stepId.unknown
    env;
}
export class GeneratePreviewResponseDto {
    previewPayloadExample;
    schema;
    novuSignature;
    result;
}
//# sourceMappingURL=preview-step-response.dto.js.map